import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "400",
  height: "174.667",
  version: "1.0",
  viewBox: "0 0 300 131"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DE0000",
      d: "M106 1.15c-51.1 1.7-84.3 9.7-96.9 23.35-25 27.1 4 70.5 60.4 90.45 52.05 18.4 137.5 21.05 176.35 5.4 40.6-16.35 56.85-37.55 53.25-69.7-2.55-22.45-14.6-29.1-61.95-34.25-4.65-.5-7.9-1.6-12-4.1C210.05 3.2 166.5-.85 106 1.15M180.4 11c7.6.55 16.85 1.55 20.5 2.25l6.6 1.25-8.25.3c-8 .25-8.25.35-8.25 2.75 0 1.95.5 2.45 2.5 2.45 1.8 0 2.5.55 2.5 1.85 0 1.75 1.3 1.95 19.25 2.4 60 1.65 75.25 8.6 75.25 34.25 0 25.6-18 44.05-55 56.35-38.45 12.75-119.05 8.2-166.2-9.45-58.7-21.9-80.25-67.85-39.35-83.9C56.7 11.05 119.8 6.6 180.4 11"
    }, null, -1)
  ])))
}
export default { render: render }